import { render, staticRenderFns } from "./ReporteCreditoUserNew.vue?vue&type=template&id=5589f222&scoped=true&"
import script from "./ReporteCreditoUserNew.vue?vue&type=script&lang=js&"
export * from "./ReporteCreditoUserNew.vue?vue&type=script&lang=js&"
import style0 from "./ReporteCreditoUserNew.vue?vue&type=style&index=0&id=5589f222&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5589f222",
  null
  
)

export default component.exports